import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  constructor(private http: HttpClient) { }


  /*-----Controller URL's----*/
  public static readonly GET_LOOKUP_VALUE_BY_LOOKUP_NAME_CONTROLLER = environment.apiURL + "getLookUpValueByName/"

  /*-----Method to Fetch lookup value by passing lookupName as parameter----*/
  public getFeedbackTypeLookUpValue(lookupName): Observable<any> {
    let params = "?lookUpName=" + lookupName;
    return this.http.get(LookupService.GET_LOOKUP_VALUE_BY_LOOKUP_NAME_CONTROLLER + params).pipe(map(responseData => {
      return responseData;
    }));
  }
}
